export let hybridspaceErrorAccessDeniedTitle = "Z8CSq";
export let hybridspaceErrorAccessDeniedSubtitle = "TmU$pb";
export let hybridspaceErrorAccessDeniedCallToAction = "maRZgb";
export let hybridspaceErrorAccessDeniedCallToActionHyperlinkText = "Dp4NEe";
export let hybridspaceErrorAccessDeniedSignOut = "ojnUYd";
export default {hybridspaceErrorAccessDeniedTitle,hybridspaceErrorAccessDeniedSubtitle,hybridspaceErrorAccessDeniedCallToAction,hybridspaceErrorAccessDeniedCallToActionHyperlinkText,hybridspaceErrorAccessDeniedSignOut};